import React from 'react';
import { HeaderText, Stack } from '../../ui';
import { ProviderService } from '../../../api/Providers/Services';
import { ServiceItem } from './ServiceItem/ServiceItem';
import { ClientProviderProfile } from '../../../api/ProfileClientView';

export type ProviderProfileLastBookedProps = {
  profile: ClientProviderProfile;
  previouslyBookedServices: ProviderService[];
  isMobile: boolean;
  handleRatingsPhotoClick: (service: ProviderService) => void;
};

export const ProviderProfileLastBooked = ({
  profile,
  previouslyBookedServices,
  isMobile,
  handleRatingsPhotoClick,
}:
ProviderProfileLastBookedProps) => (
  <Stack
    paddingX={isMobile ? 24 : 0}
    testID="last-booked-services-revamp"
  >
    <React.Fragment>
      <HeaderText level={isMobile ? 3 : 2} testID="last-booked-services-label">Last Booked</HeaderText>
      {previouslyBookedServices.map(service => (
        <ServiceItem
          key={service.id}
          service={service}
          providerId={profile.id}
          providerPhone={profile.public_phone_number}
          isOnlineBookable={(
          profile.is_effectively_online_bookable
          && !profile.is_disabled
          && !!service.is_online_bookable
          )}
          showAndUp={service.cost_and_up || profile.smart_pricing_enabled}
          onRatingsPhotosClick={handleRatingsPhotoClick}
          isLastBookedService
        />
      ))}
    </React.Fragment>
  </Stack>
);
